import { render, staticRenderFns } from "./CollectionTotalResults.vue?vue&type=template&id=183ec570&scoped=true&lang=pug&"
import script from "./CollectionTotalResults.vue?vue&type=script&lang=js&"
export * from "./CollectionTotalResults.vue?vue&type=script&lang=js&"
import style0 from "./CollectionTotalResults.vue?vue&type=style&index=0&id=183ec570&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ec570",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183ec570')) {
      api.createRecord('183ec570', component.options)
    } else {
      api.reload('183ec570', component.options)
    }
    module.hot.accept("./CollectionTotalResults.vue?vue&type=template&id=183ec570&scoped=true&lang=pug&", function () {
      api.rerender('183ec570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionTotalResults.vue"
export default component.exports